<template>
  <div class="item-preview" ref="itemPreview">
    <div class="editor-center">
      <img
        class="loading"
        :hidden="!isCalculatingZoom"
        src="../../public/assets/loading.png"
        alt="Calculando preview..."
      />
      <div
        class="item-cards"
        :style="{zoom: previewZoom}"
        :hidden="isCalculatingZoom"
        ref="itemCards"
      >
        <ItemCard>
          <BackgroundCard :item="item" />
        </ItemCard>
        <ItemCard>
          <FrontCard :item="item" />
        </ItemCard>
      </div>
      <slot />
    </div>
  </div>
</template>

<script>
  import { mapActions, mapState } from 'vuex'

  import { PREVIEW } from '../store/modules'
  import BackgroundCard from './BackgroundCard.vue'
  import FrontCard from './FrontCard.vue'
  import ItemCard from './ItemCard.vue'

  export default {
    name: 'ItemPreview',
    components: {
      BackgroundCard,
      FrontCard,
      ItemCard
    },
    computed: {
      ...mapState([ 'item' ]),
      ...mapState(PREVIEW, [
        'isCalculatingZoom',
        'previewZoom'
      ]),
    },
    mounted () {
      this.$nextTick(function() {
        window.addEventListener('resize', this.updateZoom)

        this.updateZoom()
      });
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.updateZoom)
    },
    methods: {
      ...mapActions(PREVIEW, [ 'updatePreviewZoom' ]),
      updateZoom() {
        this.updatePreviewZoom(this.$refs.itemPreview)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .item-preview {
    display: flex;
    flex-direction: column;
    height: 100%;
    max-height: 100%;
    max-width: 100%;
    width: 100%;

    @media (max-width: 576px) {
      height: auto;
      max-height: auto;
    }

    .editor-center {
      align-items: center;
      display: flex;
      justify-content: center;
      flex: 1 1 auto;

      @media (max-width: 576px) {
        height: 100vh !important;
      }
    }

    $transition: transform 1s ease-in-out;

    $maxWidth: 1500px;

    .item-cards {
      display: flex;
      max-width: $maxWidth;
      overflow: hidden;
      position: relative;
      width: $maxWidth;

      @media (max-width: 576px) {
        zoom: 0.25 !important;
      }
    }

    .generate-options {
      background-color: white;
      height: auto;
      left: 0;
      padding: .125rem 1rem;
      top: 0;
      width: 100%;

      @media (max-width: 576px) {
        background-color: transparent;
        position: relative;
      }
    }

    @keyframes spin {
      from {
        transform:rotate(0deg);
      }
      to {
        transform:rotate(360deg);
      }
    }

    .loading {
      animation-name: spin;
      height: 20em;
      width: 20em;
      animation-duration: 5000ms;
      animation-iteration-count: infinite;
      animation-timing-function: linear;
    }
  }
</style>